export const GiftCardInitialState = {
  balanceData: { success: false, error: '', data: {} },
  redeemData: { success: false, error: '', data: {} },
  loader: false
};

function ajioGiftCardData(state = GiftCardInitialState, action) {
  switch (action.type) {
    case 'SET_AJIO_GIFT_CARD_BALANCE_DATA':
      return {
        ...state,
        balanceData: { ...state.balanceData, data: action.ajioGiftCardBalanceData }
      };
    case 'GET_AJIO_GIFT_CARD_BALANCE_DATA_SUCCESS':
      return {
        ...state,
        balanceData: { ...state.balanceData, success: action.success }
      };
    case 'GET_AJIO_GIFT_CARD_BALANCE_DATA_FAIL':
      return {
        ...state,
        balanceData: { ...state.balanceData, success: action.success, error: action.error }
      };
    case 'SHOW_GIFT_CARD_LOADER':
      return { ...state, loader: true };
    case 'HIDE_GIFT_CARD_LOADER':
      return { ...state, loader: false };
    case 'RESET_GIFT_CARD_DATA': {
      if (action.onlyError) {
        const newState = { ...state };
        newState.balanceData.error = null;
        newState.redeemData.error = null;
        return newState;
      }
      return { ...GiftCardInitialState };
    }
    case 'SET_AJIO_GIFT_CARD_REDEEM_DATA':
      return {
        ...state,
        redeemData: { ...state.redeemData, data: action.ajioGiftCardRedeemData }
      };
    case 'GET_AJIO_GIFT_CARD_REDEEM_DATA_SUCCESS':
      return {
        ...state,
        redeemData: { ...state.redeemData, success: action.success }
      };
    case 'GET_AJIO_GIFT_CARD_REDEEM_DATA_FAIL':
      return {
        ...state,
        redeemData: { ...state.redeemData, success: action.success, error: action.error }
      };
    default:
      return state;
  }
}

export default ajioGiftCardData;
